import React, { Suspense, useEffect, useMemo } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { defineConfig } from './config';
import { Button, Result} from 'antd';
import { publicRoutes } from './config/routes';
import { ConfigProvider } from 'antd';
import { PermissionsProvider } from './components/Permissions/PermissionsContext';
import { ProtectedRoute } from "./components/Permissions/components/ProtectedRoute";
import { systemsService, userService } from './services';
import { CDNService } from './services/cdn.service';
import { reloadOnChunkError } from './utils/chunkReload';
import ActivityTracker from './components/ActivityTracker/ActivityTracker';

const {
    colorPrimaryBg,
    colorPrimaryBgHover,
    colorPrimaryBorder,
    colorPrimaryBorderHover,
    colorPrimaryHover,  
    colorPrimary,     
    colorPrimaryActive,    
    colorPrimaryTextHover, 
    colorPrimaryText,      
    colorPrimaryTextActive,
    colorTextBase,
    colorBgBase,
    colorBgContainer,
    colorBgElevated,
    bodyBg,
    contentBg,
    colorText,
} = defineConfig;

ConfigProvider.config({
  theme: {
    colorPrimaryBg,
    colorPrimaryBgHover,
    colorPrimaryBorder,
    colorPrimaryBorderHover,
    colorPrimaryHover,  
    colorPrimary,     
    colorPrimaryActive,    
    colorPrimaryTextHover, 
    colorPrimaryText,      
    colorPrimaryTextActive,
    colorTextBase,
    colorBgBase,
    colorBgContainer,
    colorBgElevated,
    bodyBg,
    contentBg,
    colorText
  },
});

const LogoutButton = <>
  <Button color='secondary' size="lg" className='mb-6' onClick={() => window.location.replace("/logout")}>LOGOUT</Button>
</>

const Error403 = (props) => (
  <Result
    status="403"
    //title="403"
    subTitle="Ci dispiace, la pagina non esiste."
    extra={LogoutButton}
    {...props}
  />
)
const Error404 = (props) => (
  <Result
    status="404"
    //title="404"
    subTitle="Risorsa non trovata."
    extra={<Button type="secondary" href="/">Torna alla Home</Button>}
    {...props}
  />
)

const { routes } = defineConfig

const getPageLazy = (path) => React.lazy(() => {
  return Promise.all([
    import(`${path}`),
    new Promise(resolve => setTimeout(resolve, 100))
  ])
  .then(([moduleExports]) => moduleExports)
  .catch((error) => reloadOnChunkError(error));
});

const publicPages = publicRoutes.map(route => {
  return {
    path: route.path,
    Render: getPageLazy(route.component)
  }
})

function App() {

  const authorities = useMemo(() => {
    const user = userService.getLocalUserAuthorities();
    return user || [];
  }, []);
  
  // the families of the system types, for the icons of the LANSA types
  useEffect(() => {
    if (!localStorage.getItem("auth")) return;
    systemsService.getAllSystemTypes("ALL").then(CDNService.setTypeFamilies, () => {});
  }, []);

  // Workaround resizeObserver problem
  useEffect(() => {
    window.addEventListener('error', e => {
        if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
            const resizeObserverErrDiv = document.getElementById(
                'webpack-dev-server-client-overlay-div'
            );
            const resizeObserverErr = document.getElementById(
                'webpack-dev-server-client-overlay'
            );
            if (resizeObserverErr) {
                resizeObserverErr.setAttribute('style', 'display: none');
            }
            if (resizeObserverErrDiv) {
                resizeObserverErrDiv.setAttribute('style', 'display: none');
            }
        }
    });
  }, []);

  const setDefaultHomePage = (privPage) => {
    // Si presuppone che ci sia una sola homepage
    const homePage = privPage.find(pp => pp.path === '/')
    if(!homePage.isAllowed) {
      let homeFake = privPage.find(pp => pp.isAllowed)
      if(!homeFake)
        return privPage

      homePage.Render = homeFake.Render
      homePage.isAllowed = true
      privPage = privPage.map(pp => {
        if(pp.path === '/'){
          pp = homePage
        }
        return pp
      })
    }
    return privPage
  }

  var privatePages = routes.map(route => {
    return {
      path: route.path,
      Render: getPageLazy(route.component),
      permission: route.permission,
      roles: route.roles
    }
  })

  privatePages = setDefaultHomePage(privatePages);
  const basename = window.location.pathname.startsWith("/alessi") ? "/alessi" : "/";
  
  return (
    <PermissionsProvider authorities={authorities}>
      <Suspense fallback={null}>
        <Router basename={basename}>
          <ActivityTracker />
          <Switch>
            {privatePages.map((Component, index) => 
              <ProtectedRoute
                key={index}
                exact path={Component.path}
                permission={Component.permission}
                roles={Component.roles}
              >
                <Component.Render />
              </ProtectedRoute>
            )}
            {publicPages.map((Component, index) => <Route key={index} exact path={Component.path} render={(props) => <Component.Render {...props} />} />)}
            <Route key="Error-403" exact path={"/403"} render={Error403}/>
            <Route key="Error-404" exact path={"/404"} render={Error404}/>
            <Route component={Error404}/>
          </Switch>
        </Router>
      </Suspense>
    </PermissionsProvider>
  );
}

export default App;



